











































































































































































































































































































import {
  defineComponent,
  onMounted,
  ref,
  PropType
} from "@vue/composition-api";
import { ApiResponse } from "@/api/types";
import Draggable from "vuedraggable";
import InputField from "@/components/Organisms/InputField/index.vue";
import InputFieldGroup from "@/components/Organisms/InputFieldGroup/index.vue";

import FieldAddButton from "@/components/Atoms/Forms/FieldAddButton/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccHelp from "@/components/Atoms/OccHelp/index.vue";
import TextField from "@/components/Atoms/Forms/TextField/index.vue";
import TextArea from "@/components/Atoms/Forms/TextArea/index.vue";
import ImageCropper from "@/components/Organisms/ImageCropper/index.vue";

import { JobEventDescription } from "@/api/types";
import {
  formConfig,
  RequiredDescriptionItemLabel,
  OptionalDefaultDescriptionItemLabel,
  REQUIRED_DESCRIPTION_ITEMS,
  OPTIONAL_DEFAULT_DESCRIPTION_ITEMS,
  getEventDescriptionScrollKey
} from "@/helpers/jobEvent";
import { JOB_EVENT_STORE_KEY } from "@/helpers/hooks/useJobEvent";
import { getRandomId } from "@/helpers/math-helper";
import { reorderArrayIndex } from "@/helpers/array-helper";
import { useGlobalState } from "@/helpers/hooks/useGlobalState";

export default defineComponent({
  components: {
    Draggable,
    InputField,
    InputFieldGroup,
    FieldAddButton,
    OccHeading,
    OccButton,
    OccHelp,
    TextField,
    TextArea,
    ImageCropper
  },
  name: "BasicInfoForm",
  props: {
    contracts: {
      type: Array as PropType<ApiResponse.ContractInformation[]>,
      default: () => []
    }
  },
  setup() {
    const {
      editingJobEvent,
      jobEventErrors,
      jobEventWarns,
      uncroppedImage,
      requiredDescriptionItemIds,
      optionalDefaultDescriptionItemIds,
      repeatedDescriptionItemIds,
      displayDescriptionItems,
      disabledEdit,
      setEditingJobEvent,
      setLackedRequiredDescriptionItems,
      setLackedOptionalDefaultDescriptionItems,
      getJobEventErrorMessage,
      getJobEventWarningMessage,
      resetDescriptionError
    } = useGlobalState(JOB_EVENT_STORE_KEY);

    const hoveredItemId = ref<number>();

    const getIsRequiredItem = (itemId: number) => {
      return requiredDescriptionItemIds.value.some(
        requiredItemId => requiredItemId === itemId
      );
    };

    const getIsUnequireDefaultItem = (itemId: number) => {
      return optionalDefaultDescriptionItemIds.value.some(
        requiredItemId => requiredItemId === itemId
      );
    };

    // 重複している項目かどうか
    const isNotRepeatedItem = (itemId: number) => {
      return repeatedDescriptionItemIds.value.every(
        requiredItemId => requiredItemId !== itemId
      );
    };

    const getRequiredItemPlaceholder = (
      label: RequiredDescriptionItemLabel
    ) => {
      const targetItem = REQUIRED_DESCRIPTION_ITEMS.find(
        item => item.label === label
      );
      return targetItem?.placeholder;
    };

    const getRequiredItemHelpText = (label: RequiredDescriptionItemLabel) => {
      const targetItem = REQUIRED_DESCRIPTION_ITEMS.find(
        item => item.label === label
      );
      return targetItem?.help;
    };

    const getRequiredItemUnderLabel = (label: RequiredDescriptionItemLabel) => {
      const targetItem = REQUIRED_DESCRIPTION_ITEMS.find(
        item => item.label === label
      );
      return targetItem?.underLabel;
    };

    const getOptionalDefaultItemPlaceholder = (
      label: OptionalDefaultDescriptionItemLabel
    ) => {
      const targetItem = OPTIONAL_DEFAULT_DESCRIPTION_ITEMS.find(
        item => item.label === label
      );
      return targetItem?.placeholder;
    };

    const getOptionalDefaultItemHelpText = (
      label: OptionalDefaultDescriptionItemLabel
    ) => {
      const targetItem = OPTIONAL_DEFAULT_DESCRIPTION_ITEMS.find(
        item => item.label === label
      );
      return targetItem?.help;
    };

    const onClickAdd = () => {
      const additionalItemCount = displayDescriptionItems.value.filter(
        item => !getIsRequiredItem(item.id)
      ).length;

      const additionalItem: JobEventDescription = {
        id: getRandomId(),
        label: `追加項目${additionalItemCount + 1}`,
        content: "",
        position: displayDescriptionItems.value.length + 1
      };

      const nextItems = [...displayDescriptionItems.value, additionalItem];
      if (editingJobEvent.value) {
        setEditingJobEvent({
          ...editingJobEvent.value,
          event_description_items: nextItems
        });
      }
    };

    const onClickDelete = (itemId: number) => {
      const nextItems = displayDescriptionItems.value
        .filter(item => {
          return item.id !== itemId;
        })
        .map((item, index) => {
          return {
            ...item,
            position: index + 1
          };
        });

      if (editingJobEvent.value) {
        resetDescriptionError(itemId);
        setEditingJobEvent({
          ...editingJobEvent.value,
          event_description_items: nextItems
        });
      }
    };

    const onChangeItemLabel = (itemId: number, label: string) => {
      const nextItems = displayDescriptionItems.value.map(item => {
        if (item.id === itemId) {
          return {
            ...item,
            label
          };
        }
        return item;
      });

      if (editingJobEvent.value) {
        setEditingJobEvent(
          {
            ...editingJobEvent.value,
            event_description_items: nextItems
          },
          { key: "event_description_items/label", subKey: itemId }
        );
      }
    };

    const onChangeItemContent = (itemId: number, content: string) => {
      const nextItems = displayDescriptionItems.value.map(item => {
        if (item.id === itemId) {
          return {
            ...item,
            content
          };
        }
        return item;
      });

      if (editingJobEvent.value) {
        setEditingJobEvent(
          {
            ...editingJobEvent.value,
            event_description_items: nextItems
          },
          { key: "event_description_items/content", subKey: itemId }
        );
      }
    };

    const handleDragCompetitorEnd = ({
      oldIndex,
      newIndex
    }: {
      oldIndex: number;
      newIndex: number;
    }) => {
      const reorderedItems = reorderArrayIndex(
        displayDescriptionItems.value,
        oldIndex,
        newIndex
      ).map((resume, index) => ({
        ...resume,
        position: index + 1
      }));

      if (editingJobEvent.value) {
        setEditingJobEvent({
          ...editingJobEvent.value,
          event_description_items: reorderedItems
        });
      }
    };

    onMounted(() => {
      setLackedRequiredDescriptionItems();
      setLackedOptionalDefaultDescriptionItems();
      if (editingJobEvent.value) {
        setEditingJobEvent({
          ...editingJobEvent.value,
          event_description_items: displayDescriptionItems.value.map(
            (item, index) => ({
              ...item,
              position: index + 1
            })
          )
        });
      }
    });

    return {
      editingJobEvent,
      formConfig,
      displayDescriptionItems,
      disabledEdit,
      hoveredItemId,
      jobEventErrors,
      jobEventWarns,
      uncroppedImage,
      setEditingJobEvent,
      resetDescriptionError,
      getJobEventErrorMessage,
      getJobEventWarningMessage,
      getIsRequiredItem,
      getIsUnequireDefaultItem,
      isNotRepeatedItem,
      getRequiredItemPlaceholder,
      getRequiredItemHelpText,
      getRequiredItemUnderLabel,
      getOptionalDefaultItemPlaceholder,
      getOptionalDefaultItemHelpText,
      onClickAdd,
      onClickDelete,
      onChangeItemLabel,
      onChangeItemContent,
      handleDragCompetitorEnd,
      getEventDescriptionScrollKey
    };
  }
});
